import GalleryGladys from './GalleryGladys';
import { DataGladys } from './DataGladys';

function SliderGladys() {
  return <GalleryGladys slides={DataGladys} />;
}

export default SliderGladys;